import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  busy: boolean;
  error: string | null;
  templateName?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const RegenerateReportDialog = ({ open, busy, error, templateName, onCancel, onConfirm }: Props) => (
  <Dialog
    open={open}
    onClose={busy ? undefined : onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { bgcolor: '#1a2336', color: '#e2e8f0' } }}
  >
    {/* DialogTitle takes the theme's heading font (serif here); match the body text. */}
    <DialogTitle
      sx={{ fontSize: 16, fontWeight: 600, fontFamily: theme => theme.typography.body1.fontFamily }}
    >
      Regenerate report?
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ fontSize: 14, mb: 1.5 }}>
        The report body will be rebuilt from the current
        {templateName ? ` "${templateName}"` : ''} template, with fresh measurements and
        patient details.
      </Typography>
      <Typography sx={{ fontSize: 14, mb: 1.5, color: '#fca5a5' }}>
        Everything typed or selected in the report will be lost. No copy is kept.
      </Typography>
      <Typography sx={{ fontSize: 13, color: '#94a3b8' }}>
        Kept: assigned cardiologist, sonographer, wall-motion colours and attached clips.
      </Typography>
      {error && (
        <Alert
          severity="error"
          sx={{ mt: 2 }}
        >
          {error}
        </Alert>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        onClick={onCancel}
        disabled={busy}
        sx={{ color: '#e2e8f0' }}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        disabled={busy}
        variant="contained"
        color="error"
        startIcon={busy ? <CircularProgress size={14} color="inherit" /> : null}
      >
        {busy ? 'Regenerating…' : 'Regenerate'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RegenerateReportDialog;
